<template>
  <div class="housing-locality-slider-card">
    <LoadSpinner v-if="loading"/>

    <div
      v-else-if="!error"
      class="housing-locality-slider-card__card"
    >
      <div
        v-if="title"
        class="housing-locality-slider-card__title"
      >
        {{title}}
      </div>
      <div class="housing-locality-slider-card__slider" ref="flickitySlider">
        <template v-for="(image, index) in filteredImages" :key="index">
          <div
            class="housing-locality-slider-card__cell"
            :style="`background-image: url(${image.storage_thumbnail})`"
          />
        </template>
      </div>
      <a :href="housingLocalityUrl(housingLocality)">
        <div class="housing-locality-slider-card__name">
          {{housingLocality.mpc_name}}
        </div>
        {{housingLocality.township.mpc_name}},
        {{housingLocality.mpc_postinumero}}
        {{housingLocality.city.mpc_name}}
      </a>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import Flickity from 'flickity';

  import globals from '../lib/globals';
  import utils from './mixins/utils';
  import LoadSpinner from './components/LoadSpinner';

  export default {
    mixins: [
      utils.housingLocalityUrl,
    ],
    components: {
      LoadSpinner,
    },
    props: {
      uuid: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        error: false,
        loading: false,
        housingLocality: null,
        flickityInstance: null,
        flickityOptions: {
          prevNextButtons: false,
          autoPlay: 5000,
          wrapAround: true,
        },
      };
    },
    computed: {
      filteredImages() {
        if (!this.housingLocality || !this.housingLocality.imagesForWeb) {
          return [];
        }
        return this.housingLocality.imagesForWeb.filter(image => image.type !== 'Myyntiasiakirja');
      },
    },
    async beforeMount() {
      this.loading = true;

      try {
        const response = await axios.get(globals.urlIntegrationApi + '/public/housinglocality/' + this.uuid);
        this.housingLocality = response.data;
      } catch (error) {
        this.error = true;
      }

      this.loading = false;
    },
    async mounted() {
      // Wait for data to load and DOM to update
      this.$watch('loading', async (newVal) => {
        if (!newVal && !this.error && this.$refs.flickitySlider) {
          await this.$nextTick();
          this.flickityInstance = new Flickity(this.$refs.flickitySlider, this.flickityOptions);
        }
      });
    },
    beforeUnmount() {
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
    },
  };
</script>

<style lang="scss">
  @import "~styles/definitions";

  .housing-locality-slider-card {
  }

  .housing-locality-slider-card__card {
    @include card;
    display: block;
    padding: r(8) r(8) r(24);
    background-color: $color-white;
    text-align: center;
  }

  .housing-locality-slider-card__title {
    @include font-h-28;
    margin: r(16) 0 r(24);
  }

  .housing-locality-slider-card__slider {
    margin-bottom: r(28);

    .flickity-page-dots {
      bottom: 0;
      height: 0;
    }

    .flickity-page-dots .dot {
      @include square(r(20));
      background-color: #d8d8d8;
      opacity: 1;
      box-shadow: 0 r(2) r(4) 0 rgba(0, 0, 0, 0.4);
      margin: 0 r(4);
      transform: translateY(r(-44));

      &.is-selected {
        background-color: $color-green-2025;
      }
    }
  }

  .housing-locality-slider-card__cell {
    @include bg-cover;
    width: 100%;
    min-height: r(288);
  }

  .housing-locality-slider-card__name {
    @include font-heavy-16;
    margin-bottom: r(8);
  }
</style>
